import $ from 'jquery';

$(function(){

  // $('.team-carousel').slick({
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 3,
  //   dots: true,
  //   arrows: false,
  //   autoplay: true,
  // });

  $('.awards-carousel').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });

  $('.blog-carousel-carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 10000,
  });
  
  $('.quote-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 10000,
  });

  var stagesCarousel1 = $('.stages-carousel-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var stagesCarousel2 = $('.stages-carousel-2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var stagesCarousel3 = $('.stages-carousel-3').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var stagesCarousel4 = $('.stages-carousel-4').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  stagesCarousel1.slick("slickPause");

  setTimeout(function() {
    stagesCarousel1.slick("slickPlay");
  }, 1250);

  stagesCarousel2.slick("slickPause");

  setTimeout(function() {
    stagesCarousel2.slick("slickPlay");
  }, 2500);

  stagesCarousel3.slick("slickPause");

  setTimeout(function() {
    stagesCarousel3.slick("slickPlay");
  }, 3750);

  stagesCarousel4.slick("slickPause");

  setTimeout(function() {
    stagesCarousel4.slick("slickPlay");
  }, 5000);

  var imagesCarousel1 = $('.images-carousel-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel2 = $('.images-carousel-2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel3 = $('.images-carousel-3').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel4 = $('.images-carousel-4').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel5 = $('.images-carousel-5').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel6 = $('.images-carousel-6').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel7 = $('.images-carousel-7').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel8 = $('.images-carousel-8').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  var imagesCarousel9 = $('.images-carousel-9').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    pauseOnHover:false,
    cssEase: 'linear'
  });

  imagesCarousel1.slick("slickPause");

  setTimeout(function() {
    imagesCarousel1.slick("slickPlay");
  }, 1000);

  imagesCarousel2.slick("slickPause");

  setTimeout(function() {
    imagesCarousel2.slick("slickPlay");
  }, 9000);

  imagesCarousel3.slick("slickPause");

  setTimeout(function() {
    imagesCarousel3.slick("slickPlay");
  }, 2000);

  imagesCarousel4.slick("slickPause");

  setTimeout(function() {
    imagesCarousel4.slick("slickPlay");
  }, 8000);

  imagesCarousel5.slick("slickPause");

  setTimeout(function() {
    imagesCarousel5.slick("slickPlay");
  }, 3000);

  imagesCarousel6.slick("slickPause");

  setTimeout(function() {
    imagesCarousel6.slick("slickPlay");
  }, 7000);

  imagesCarousel7.slick("slickPause");

  setTimeout(function() {
    imagesCarousel7.slick("slickPlay");
  }, 4000);

  imagesCarousel8.slick("slickPause");

  setTimeout(function() {
    imagesCarousel8.slick("slickPlay");
  }, 6000);

  imagesCarousel9.slick("slickPause");

  setTimeout(function() {
    imagesCarousel9.slick("slickPlay");
  }, 5000);


  var $placesslider = $('.places');
  
  // Initialize Slick Slider
  $placesslider.slick({
    // Slick Slider options here
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: false,
    variableWidth: true
  });
  
  // Function to check window width and disable/enable slider
  function checkSlider() {
    if ($(window).width() > 768) {
      $placesslider.slick('unslick'); // Disable Slick Slider
    } else {
      $placesslider.slick({ // Re-enable Slick Slider
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        arrows: false
      });
    }
  }
  
  // Initial check
  checkSlider();
  
  // Check on window resize
  // $(window).resize(function(){
  //   checkSlider();
  // });

});

//places carousel

// JavaScript to handle carousel functionality

// document.addEventListener("DOMContentLoaded", function() {
//   const placesElements = document.querySelectorAll('.places-element');
//   let currentIndex = 0;

//   function showNextTwo() {
//       // Hide all places-elements
//       placesElements.forEach(element => {
//           // element.style.display = 'none';
//           element.style.opacity = '0';
//       });

//       // Show the next two places-elements with fading in
//       // placesElements[currentIndex % placesElements.length].style.display = 'block';
//       placesElements[currentIndex % placesElements.length].style.opacity = '1';
//       // placesElements[(currentIndex + 1) % placesElements.length].style.display = 'block';
//       placesElements[(currentIndex + 1) % placesElements.length].style.opacity = '1';

//       // Increment the index for next iteration
//       currentIndex += 2;
//   }

//   // Call showNextTwo initially
//   showNextTwo();

//   // Call showNextTwo every certain period of time
//   setInterval(showNextTwo, 3000); // Change 5000 to the desired interval in milliseconds

// });